import { ReactNode, useState } from 'react'

import { useApplyBodyClass } from 'hooks/useScrollEffects'

import Icon from 'components/elements/Icon'

import styles from './tooltip.module.scss'

type Props = {
  children?: ReactNode
  trigger?: React.ReactNode
  className?: string
  style?: React.CSSProperties
  onHover?: (e: React.MouseEvent) => void
}

const Tooltip = ({ children = null, trigger = null, style, className = '', onHover }: Props) => {
  const [hovered, setHovered] = useState(false)

  useApplyBodyClass(hovered, 'no-scrolling')

  return (
    <span
      className={styles.parent}
      onMouseEnter={e => {
        setHovered(true)

        if (onHover) onHover(e)
      }}
      onMouseLeave={() => setHovered(false)}>
      {trigger ? trigger : <Icon color="grey" name="info circle" />}

      {hovered && (
        <div className={`${styles.tooltip} ${className}`} style={style}>
          {children}
        </div>
      )}
    </span>
  )
}

export default Tooltip
